export const TX_BROADCASTED = 'TX_BROADCASTED';
export const TX_BROADCAST_RECEIVED = 'TX_BROADCAST_RECEIVED';
export const TX_SUCCESSFUL = 'TX_SUCCESSFUL';
export const TX_ERROR = 'TX_ERROR';
export const CONTRACT_SYNC_IND = 'CONTRACT_SYNC_IND';
export const CONTRACT_SYNCED = 'CONTRACT_SYNCED';
export const CONTRACT_SYNC_RECEIVED = 'CONTRACT_SYNC_RECEIVED';
export const BLOCK_RECEIVED = 'BLOCK_RECEIVED';
export const RESERVE_INITIALIZING = 'RESERVE_INITIALIZING';
export const RESERVE_INITIALIZED = 'RESERVE_INITIALIZED';
export const RESERVE_ADDED = 'RESERVE_ADDED';
export const RESERVE_CHANGE_QUEUE = 'RESERVE_CHANGE_QUEUE';
export const RESERVE_COMPLETED = 'RESERVE_COMPLETED';
export const RESERVE_CHANGE_NONCE = 'RESERVE_CHANGE_NONCE';
export const RESERVE_BLOCK_RECEIVED = 'RESERVE_BLOCK_RECEIVED';
export const RESERVE_AFTER_SYNC = 'RESERVE_AFTER_SYNC';
export const VERTHEIGHT_DETERMINDED = 'VERTHEIGHT_DETERMINDED';
